import { Pipe, PipeTransform } from "@angular/core"
import * as moment from "moment"
import { TrDatePipe } from "./tr-date.pipe"

@Pipe({
  name: "trMomentFormat",
})
export class TrMomentFormatPipe implements PipeTransform {
  public transform(date: any, format: string): string {
    const newDate = TrDatePipe.toDate(date)
    if (!newDate) {
      return ""
    }

    return moment(newDate).format(format)
  }
}
